module.exports = __webpack_public_path__ + "img/kirakira.05079c04.jpg";